<template>
  <div class="churn-flow">
    <div class="app-header">
      <back-navigation-header :show-back="step === 3" :onBack="prevStep"/>
    </div>
    <div class="content">
      <churn-goodbye-page v-if="step === 1" :start-survey="nextStep"/>
      <churn-survey-options-question
        v-else-if="step === 2"
        title="נשמח לדעת למה החלטת לעזוב"
        next-step-text="אפשר להמשיך"
        :next-step="nextStep"
        :options="optionsForQ1"
        :question-number="1"/>
      <churn-survey-options-question
        v-else-if="step === 3"
        :title="titleForQ2"
        next-step-text="סיימתי"
        :next-step="nextStep"
        :options="optionsForQ2"
        :question-number="2"/>
      <churn-survey-free-text v-else-if="step === 4" :next-step="nextStep"/>
      <churn-survey-end v-else-if="step === 5"/>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import * as _ from 'lodash';
import Segment from '@/Segment';
import BackNavigationHeader from '@/base-components/app-header/BackNavigationHeader';
import ChurnSurveyFreeText from '@/pages/responsive-pages/non-authenticated/churn/ChurnSurveyFreeText';
import ChurnSurveyOptionsQuestion from '@/pages/responsive-pages/non-authenticated/churn/ChurnSurveyOptionsQuestion';
import ChurnSurveyEnd from '@/pages/responsive-pages/non-authenticated/churn/ChurnSurveyEnd';
import ChurnGoodbyePage from './ChurnGoodbyePage.vue';

const answersTree = [
  {
    answer: 'השירות לא עזר לי',
    titleForQ2: 'למה השירות לא עזר לך?',
    optionsForQ2: [
      'השירות לא שיפר את המצב שלי',
      'לא הבנתי את התזרים',
      'לא השתמשתי בתזרים',
      'אני אסתדר בלי זה',
    ],
  }, {
    answer: 'התזרים לא שיקף נכון את המצב שלי',
    titleForQ2: 'למה התזרים לא היה נכון?',
    optionsForQ2: [
      'היו שגיאות במידע שהוצג',
      'אי אפשר לעדכן הוצאות והכנסות ידנית',
      'לא מתאים לי תזרים מה-1 בחודש',
      'אין מספיק יכולות עריכה',
    ],
  }, {
    answer: 'לא היה לי נוח',
    titleForQ2: 'מה היה לא נוח?',
    optionsForQ2: [
      'אין אפליקציה',
      'הודעות ה-Whatsapp הפריעו לי',
      'יש יותר מדי עדכוני סיסמאות',
      'דיוק התזרים דרש הרבה עבודה',
    ],
  }, {
    answer: 'לא מרגיש בטוח',
    titleForQ2: 'מה לא מרגיש בטוח?',
    optionsForQ2: [
      'יש לי חשש לגבי פרטיות המידע שלי',
      'יש לי חשש שיפרצו לשירות',
      'יש לי חשש ממה שתעשו עם המידע שלי',
    ],
  }, {
    answer: 'השירות יקר מדי',
    titleForQ2: 'השירות יקר מדי',
    optionsForQ2: [
      'יש שירותים זולים יותר',
      'באפליקציה של הבנק יש שירות דומה',
      'לא שווה לי את המחיר',
      'אין לי כסף לשלם על זה כרגע',
    ],
  },
];

export default {
  name: 'ChurnFlow',
  components: {
    BackNavigationHeader,
    ChurnGoodbyePage,
    ChurnSurveyOptionsQuestion,
    ChurnSurveyFreeText,
    ChurnSurveyEnd,
  },
  data() {
    return {
      step: 1,
    };
  },
  computed: {
    ...mapState('churnSurvey', ['answers']),
    optionsForQ1() {
      return _.map(answersTree, ({ answer }) => answer);
    },
    answerTreeForQ2() {
      return _.find(answersTree, ({ answer }) => answer === this.answers.q1Answer) || {};
    },
    titleForQ2() {
      return this.answerTreeForQ2.titleForQ2;
    },
    optionsForQ2() {
      return this.answerTreeForQ2.optionsForQ2;
    },
  },
  methods: {
    nextStep() {
      this.step++;
    },
    prevStep() {
      Segment.trackUserInteraction('ChurnSurveyPrevStepClicked', {
        fromPage: this.step,
      });
      this.step--;
    },
  },
};
</script>

<style lang="scss" scoped>
.churn-flow {
  display: flex;
  flex-direction: column;
  height: 100%;

  .app-header {
    flex-grow: 0;
  }

  .content {
    flex-grow: 1;
  }
}
</style>
